import React, { useEffect, useState } from 'react';
import { HashRouter } from 'react-router-dom';
import AppRoutes from './routes/Routes';
import './styles/main.scss';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoaderProvider } from './Loader/LoaderContext';
import GlobalLoader from './Loader/GlobalLoader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FundContextProvider } from "./Context/FundManagementContext";
import { useClearQueryParamsOnRouteChange } from "./useClearQueryParamsOnRouteChange";
import MaintenanceScreen from './pages/Maintenance/MaintenanceScreen';
import { useSessionStorageSync } from './hooks/useSessionStorageSync';

const queryClient = new QueryClient();

const App: React.FC = () => {
  const [isMaintenance, setIsMaintenance] = useState<boolean>(false);

  useEffect(() => {
    // --- Option A: Static flag via environment variable ---
    const maintenanceFlag = process.env.REACT_APP_MAINTENANCE_MODE === "true";
    setIsMaintenance(maintenanceFlag);
  }, []);
  useSessionStorageSync();
  if (isMaintenance) {
    return <MaintenanceScreen />;
  }
  return (
    <FundContextProvider>
      <QueryClientProvider client={queryClient}>
        <LoaderProvider>
          <HashRouter>
            <AppWithQueryCleanup />
          </HashRouter>
        </LoaderProvider>
      </QueryClientProvider>
    </FundContextProvider>
  );
};

const AppWithQueryCleanup: React.FC = () => {
  useClearQueryParamsOnRouteChange(['prefix', 'text']);

  return (
    <>
      <GlobalLoader />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
      <AppRoutes />
    </>
  );
};

export default App;
